import {
  PORTAL_LINK_BASE_PATH,
  PORTAL_LINK_BIDS_PATH,
  PORTAL_LINK_SHIPMENTS_PATH,
  PORTAL_LINK_TENDER_PATH,
} from 'rate-command-center/ui/PortalLinkRoute'
import { PORTAL_BASE_PATH } from 'shipperguide/core/ui/PortalRoute'

/** @deprecated Remove after magic-link portal migration (US-2). */
export const LEGACY_ALL_IN_ONE_PATH = '/all-in-one'

/** Prefix routes that run through {@link resolveLegacyPortalPath}. */
export const LEGACY_PORTAL_PREFIX_ROUTES = [
  LEGACY_ALL_IN_ONE_PATH,
  '/shipment',
  '/tender',
  '/rfp',
  '/spot-quote',
] as const

/** Exact routes that run through {@link resolveLegacyPortalPath}. */
export const LEGACY_PORTAL_EXACT_ROUTES = [
  PORTAL_LINK_BASE_PATH,
  `${PORTAL_BASE_PATH}/tender`,
] as const

const TOP_LEVEL_PORTAL_PREFIXES = [
  { legacy: '/shipment', target: `${PORTAL_BASE_PATH}/shipment` },
  { legacy: '/rfp', target: `${PORTAL_BASE_PATH}/rfp` },
  { legacy: '/spot-quote', target: `${PORTAL_BASE_PATH}/bids/spot-quote` },
] as const

function resolveTenderPath(remainder: string): string {
  return remainder ? `${PORTAL_BASE_PATH}/tender/${remainder}` : PORTAL_LINK_TENDER_PATH
}

function resolveAllInOneSuffix(rawSuffix: string): string {
  const suffix = rawSuffix.replace(/\/$/, '')

  if (!suffix) {
    return PORTAL_LINK_BIDS_PATH
  }

  if (suffix === 'tender' || suffix.startsWith('tender/')) {
    const remainder = suffix === 'tender' ? '' : suffix.slice('tender/'.length)
    return resolveTenderPath(remainder)
  }

  if (suffix === 'bids') {
    return PORTAL_LINK_BIDS_PATH
  }

  if (suffix === 'shipments') {
    return PORTAL_LINK_SHIPMENTS_PATH
  }

  if (suffix.startsWith('bids/')) {
    return `${PORTAL_BASE_PATH}/${suffix}`
  }

  return `${PORTAL_BASE_PATH}/${suffix}`
}

function resolveTopLevelLegacyPath(pathname: string): string | null {
  if (pathname === '/tender' || pathname.startsWith('/tender/')) {
    const remainder = pathname.slice('/tender'.length).replace(/^\//, '')
    return resolveTenderPath(remainder)
  }

  for (const { legacy, target } of TOP_LEVEL_PORTAL_PREFIXES) {
    if (pathname === legacy || pathname.startsWith(`${legacy}/`)) {
      return `${target}${pathname.slice(legacy.length)}`
    }
  }

  return null
}

/**
 * Maps legacy invite URLs to their canonical portal or portal-link targets.
 * Returns null when the pathname is already canonical (no redirect needed).
 */
export function resolveLegacyPortalPath(pathname: string): string | null {
  if (pathname.startsWith(`${PORTAL_LINK_BASE_PATH}/`)) {
    return null
  }

  if (pathname === PORTAL_LINK_BASE_PATH) {
    return PORTAL_LINK_SHIPMENTS_PATH
  }

  if (pathname === `${PORTAL_BASE_PATH}/tender`) {
    return PORTAL_LINK_TENDER_PATH
  }

  if (pathname === LEGACY_ALL_IN_ONE_PATH || pathname.startsWith(`${LEGACY_ALL_IN_ONE_PATH}/`)) {
    const suffix = pathname.slice(LEGACY_ALL_IN_ONE_PATH.length).replace(/^\//, '')
    return resolveAllInOneSuffix(suffix)
  }

  return resolveTopLevelLegacyPath(pathname)
}
